import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class OriginsServices {
  getOrigins = params =>
    AxiosClient.get("/api/app/capacitacion_origen/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getOriginsById = id =>
    AxiosClient.get(`/api/app/capacitacion_origen/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveOrigins = data =>
    AxiosClient.post("/api/app/capacitacion_origen/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editOrigins = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_origen/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteOrigins = id =>
    AxiosClient.delete(`/api/app/capacitacion_origen/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new OriginsServices();